import React from "react";
import Header from "../components/Header";
import TitleBar from "../components/TitleBar";
import Footer from "../components/Footer";
import SideBar from "../components/SideBar";
import "../styles/Home.css";
import image from "../images/img-perfil.png";
import { FiDownload } from "react-icons/fi";
import MenuMobile from "../components/MenuMobile";
import Typical from "react-typical";

function Home() {
  return (
    <body>
      <TitleBar />
      <section className="flex-container">
        <SideBar />
        <section className="main-container">
          <Header />
          <MenuMobile />
          <main className="main-wrapper home">
            <div className="home-content">
              <p>
                <span className="span">{"<"}</span>hello, hello, hello 👋 eu sou
              </p>
              <h1>
                Carlos Tavares <span className="span">{"/>"}</span>{" "}
              </h1>
              <Typical
                steps={[
                  "Full Stack Software Engineer",
                  1000,
                  "Young Lawyer",
                  1000,
                  "Ballet Dancer",
                  2000,
                ]}
                loop={Infinity}
                wrapper="h2"
              />
              <a
                href="https://drive.google.com/file/d/1cH6_iDUou2b1Df0T_nB_rLRj0i2a76xE/view?usp=sharing"
                target="_blank"
                className="btn-download"
                rel="noreferrer"
              >
                Download CV
                <FiDownload />
              </a>
            </div>
            <img
              src={image}
              alt="Foto de perfil de Carlos Tavares"
              className="image-perfil"
            />
          </main>
        </section>
        {<SideBar />}
      </section>
      <Footer />
    </body>
  );
}

export default Home;
